import { ExternalLink, Award } from 'lucide-react'
import {
  SiMeta,
  SiGoogle,
  SiCoursera,
} from 'react-icons/si'
import { certifications } from '../data/certifications'
import useInView from '../lib/useInView'

const ICON_MAP = {
  SiMeta,
  SiIbm: SiCoursera,   // react-icons has no SiIbm — use Coursera logo instead
  SiGoogle,
  SiCoursera,
}

export default function Certifications() {
  const [ref, visible] = useInView()

  return (
    <section id="certifications" className="section-padding bg-[#050505]">
      <div className="section-container" ref={ref}>

        <div className={`mb-14 transition-all duration-700 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <span className="section-label">// 05. certifications</span>
          <h2 className="section-heading">Certifications</h2>
          <div className="section-divider" />
          <p className="text-[#94a3b8] max-w-xl">
            Professional certificates completed alongside my degree.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {certifications.map((cert, i) => {
            const IconComponent = ICON_MAP[cert.icon]

            return (
              <a
                key={cert.id}
                href={cert.credentialUrl}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={`${cert.name} — ${cert.issuer}`}
                className={`card-hover group flex items-start gap-4 p-5 rounded-2xl border border-[#1e293b] bg-[#111111] transition-all duration-700 ${
                  visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
                }`}
                style={{ transitionDelay: `${i * 90}ms` }}
              >
                <div className="w-12 h-12 rounded-xl border border-[#1e293b] bg-[#0d0d0d] flex items-center justify-center flex-shrink-0 group-hover:border-indigo-500/40 transition-colors duration-200">
                  {IconComponent
                    ? <IconComponent size={22} style={{ color: cert.color }} />
                    : <Award size={22} className="text-indigo-400" />
                  }
                </div>

                <div className="flex-1 min-w-0">
                  <div className="flex items-start justify-between gap-2">
                    <h3 className="text-sm font-semibold text-[#f1f5f9] group-hover:text-indigo-300 transition-colors duration-200 leading-tight">
                      {cert.name}
                    </h3>
                    <ExternalLink size={11} className="text-[#94a3b8] group-hover:text-indigo-400 flex-shrink-0 mt-0.5 transition-colors duration-200" />
                  </div>
                  <p className="text-xs text-[#94a3b8] mt-1">{cert.issuer}</p>
                  <div className="flex items-center gap-2 mt-2">
                    <span className="font-mono text-xs text-cyan-400 bg-cyan-500/10 border border-cyan-500/20 px-2 py-0.5 rounded-full">
                      {cert.level}
                    </span>
                    <span className="font-mono text-xs text-[#94a3b8]">{cert.year}</span>
                  </div>
                </div>
              </a>
            )
          })}
        </div>
      </div>
    </section>
  )
}
